import { z } from 'zod';

export const DSLMultiMatchQueryDTO = z.object({
  multi_match: z.object({
    query: z.string(),
    fields: z.array(z.string()),
    type: z
      .enum([
        'best_fields',
        'most_fields',
        'cross_fields',
        'phrase',
        'phrase_prefix',
        'bool_prefix',
      ])
      .optional(),
    operator: z.enum(['and', 'or']).optional(),
    boost: z.number().optional(),
  }),
});

export type DSLMultiMatchQuery = z.infer<typeof DSLMultiMatchQueryDTO>;